import * as yup from "yup"

import { EUserConfiguracionAntifraudeEstado } from "../enums"

export const leyAntiFraudeFormSchema = yup.object().shape({
  estado: yup
    .number()
    .nullable()
    .oneOf([
      EUserConfiguracionAntifraudeEstado.Exento,
      EUserConfiguracionAntifraudeEstado.Verifactu,
      null,
    ])
    .required("Debe seleccionar Verifactu o Exento"),
  motivo: yup.string().when("estado", {
    is: EUserConfiguracionAntifraudeEstado.Exento,
    then: (schema) => schema.required("El motivo es obligatorio"),
    otherwise: (schema) => schema.notRequired(),
  }),
  file: yup.mixed().when("estado", {
    is: EUserConfiguracionAntifraudeEstado.Verifactu,
    then: (schema) => schema.required("El PDF es obligatorio"),
    otherwise: (schema) => schema.notRequired(),
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}) as any
